import GeetestModule, { type CaptchaVerifyResult } from './GeetestModule'

/**
 * Start GeeTest captcha verification
 * @param captchaID - The GeeTest captcha ID
 * @returns Promise with verification result
 */
export function startCaptcha(captchaID: string): Promise<CaptchaVerifyResult> {
  return GeetestModule.verify(captchaID)
}

/**
 * Cancel ongoing captcha verification
 */
export function cancelCaptcha(): void {
  GeetestModule.cancel()
}
